import { IconProp } from "@fortawesome/fontawesome-svg-core"

export enum Value {
    INFORMATION = 'INFORMATION',
    OBJECTLOGS = 'OBJECTLOGS',
    MEMBERS = 'MEMBERS',
    CONNECTEDUSERS = 'CONNECTEDUSERS',
    TRACKINGS = 'TRACKINGS',
    ACTIVITIES = 'ACTIVITIES',
    USERRELATIONS = 'USERRELATIONS',
    USERSCHOOLUNITS = 'USERSCHOOLUNITS',
    GROUPS = 'GROUPS',
    SCHEDULE = 'SCHEDULE',
    CLASSES = 'CLASSES',
    STATUS = 'STATUS',
    CONFIGURATION = 'CONFIGURATION',
    MODULEINSTANCERUN = 'MODULEINSTANCERUN',
    INSTANCELOGS = 'INSTANCELOGS',
    INSTANCEPHASESTATISTICS = 'INSTANCEPHASESTATISTICS',
    SYLLABUS = 'SYLLABUS',
    PERIODS = 'PERIODS',
    COMBINETEAMS = 'COMBINETEAMS',
    TOOLS = 'TOOLS',
}

export interface Tab {
    value: string,
    url: string,
    icon: IconProp
}

export class Tabs {
    static Information: Tab = { value: Value.INFORMATION, url: "information", icon: "circle-info" }
    static ObjectLogs: Tab = { value: Value.OBJECTLOGS, url: "objectLogs", icon: "exclamation-triangle" }
    static Members: Tab = { value: Value.MEMBERS, url: "members", icon: "users" }
    static ConnectedUsers: Tab = { value: Value.CONNECTEDUSERS, url: "connectedUsers", icon: "users" }
    static Trackings: Tab = { value: Value.TRACKINGS, url: "trackings", icon: "shoe-prints" }
    static Activities: Tab = { value: Value.ACTIVITIES, url: "activities", icon: "clipboard" }
    static UserRelations: Tab = { value: Value.USERRELATIONS, url: "userrelations", icon: "user" }
    static UserSchoolUnits: Tab = { value: Value.USERSCHOOLUNITS, url: "schoolUnits", icon: "school" }
    static Groups: Tab = { value: Value.GROUPS, url: "groups", icon: "users-rectangle" }
    static Schedule: Tab = { value: Value.SCHEDULE, url: "schedule", icon: "calendar-alt" }
    static Classes: Tab = { value: Value.CLASSES, url: "classes", icon: "users-rectangle" }
    static Status: Tab = { value: Value.STATUS, url: "status", icon: "chart-simple" }
    static Configuration: Tab = { value: Value.CONFIGURATION, url: "configuration", icon: "cog" }
    static ModuleInstanceRun: Tab = { value: Value.MODULEINSTANCERUN, url: "moduleInstanceRun", icon: "car-side" }
    static InstanceLogs: Tab = { value: Value.INSTANCELOGS, url: "instancelogs", icon: "list-check" }
    static InstancePhaseStatistics: Tab = { value: Value.INSTANCEPHASESTATISTICS, url: "phaseStatistics", icon: "chart-bar" }
    static Syllabus: Tab = { value: Value.SYLLABUS, url: "syllabus", icon: "scroll" }
    static Periods: Tab = { value: Value.PERIODS, url: "periods", icon: "calendar-alt" }
    static CombineTeams: Tab = { value: Value.COMBINETEAMS, url: "combineTeams", icon: "link" }
    static Tools: Tab = { value: Value.TOOLS, url: "tools", icon: "screwdriver-wrench" } 
}
